export default __webpack_public_path__ + "ec832fb33a40a09c885f524ffa18edc6.png";